import { CAR_TYPES, PAGE_CAR_SUBTYPES, PAGE_CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';
import { getPlural } from 'client/utils/plural';
import { getFormattedSubtypeName } from 'site-modules/upper-funnel/utils/seo-content';
import {
  getUserFriendlyTypeName,
  TYPE_DISPLAY_MAPPING,
  TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING,
} from 'site-modules/shared/utils/upper-funnel/type-mapping';

/**
 * Map subtype names for special cases where [@subtype @type] pattern does not apply/
 * @type
 * @subtype
 */
export const DISPLAY_EXCEPTION_TYPES_SUBTYPES_MAPPING = [
  {
    type: PAGE_CAR_TYPES.CONVERTIBLE,
    subtype: PAGE_CAR_SUBTYPES.CARS,
    heading: 'Convertible Cars',
    description: `${PAGE_CAR_TYPES.CONVERTIBLE} car`,
  },
  {
    type: PAGE_CAR_TYPES.HATCHBACK,
    subtype: PAGE_CAR_SUBTYPES.HOT_HATCHES,
    heading: `Hot Hatchbacks`,
    description: `hot ${PAGE_CAR_TYPES.HATCHBACK}`,
  },
  {
    type: CAR_TYPES.ELECTRIC,
    subtype: PAGE_CAR_SUBTYPES.LUXURY_ELECTRIC_CARS,
    heading: `Luxury ${TYPE_DISPLAY_MAPPING[CAR_TYPES.ELECTRIC]}s`,
    description: 'luxury electric car',
  },
  {
    type: CAR_TYPES.ELECTRIC,
    subtype: PAGE_CAR_SUBTYPES.LUXURY_ELECTRIC_SUVS,
    heading: `Luxury Electric ${TYPE_DISPLAY_MAPPING[CAR_TYPES.SUV]}s`,
    description: `luxury electric ${TYPE_DISPLAY_MAPPING[CAR_TYPES.SUV]}`,
  },
  {
    type: CAR_TYPES.ELECTRIC,
    subtype: PAGE_CAR_SUBTYPES.AWD,
    heading: `${TYPE_DISPLAY_MAPPING.awd} Electric Vehicles`,
    description: `${TYPE_DISPLAY_MAPPING.awd} electric vehicle`,
  },
  {
    type: PAGE_CAR_TYPES.HYBRID,
    subtype: PAGE_CAR_SUBTYPES.PLUG_IN_HYBRID_CARS,
    heading: 'Plug-in Hybrid Cars',
    description: 'plug-in hybrid car',
  },
  {
    type: PAGE_CAR_TYPES.HYBRID,
    subtype: PAGE_CAR_SUBTYPES.PLUG_IN_HYBRID_SUVS,
    heading: `Plug-in Hybrid ${TYPE_DISPLAY_MAPPING[CAR_TYPES.SUV]}s`,
    description: `plug-in hybrid ${TYPE_DISPLAY_MAPPING[CAR_TYPES.SUV]}`,
  },
  {
    type: PAGE_CAR_TYPES.TRUCK,
    subtype: PAGE_CAR_SUBTYPES.HEAVY_DUTY,
    heading: 'Heavy-Duty Trucks',
    description: `${PAGE_CAR_SUBTYPES.HEAVY_DUTY} truck`,
  },
];

export const getSubtypeDisplayTitle = (type, subtype, isLowercase, isPlural) => {
  const exceptionDisplay = DISPLAY_EXCEPTION_TYPES_SUBTYPES_MAPPING.filter(
    obj => obj.type === type && obj.subtype === subtype
  );

  if (exceptionDisplay.length) {
    if (isLowercase) {
      return isPlural ? `${exceptionDisplay[0].description}s` : exceptionDisplay[0].description;
    }
    return exceptionDisplay[0].heading;
  }

  if (type.includes('electric') && subtype.includes('electric')) {
    const unCapitalized = subtype
      .replaceAll('-', ' ')
      .replace(/\b(suv|awd)\b/g, match => match.toUpperCase())
      .replace('3 row', '3-row');
    return isLowercase ? unCapitalized : unCapitalized.replace(/\b([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  if (isLowercase) {
    const categoryType = Object.keys(TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING).includes(type)
      ? getUserFriendlyTypeName(type)
      : type;
    return `${subtype} ${categoryType}`;
  }

  const typeName = getPlural(getUserFriendlyTypeName(type), undefined, undefined, true);
  const subtypeName = getFormattedSubtypeName(subtype);
  return `${subtypeName} ${typeName}`;
};
